export default (function () {
  return new Date();
});
//# sourceMappingURL=getDate.js.map